/** Wallet amounts are integer cents; one credit matches one dollar at the standard rate (PLAN C1, PRD J2). */

/** `1250` → `"12.5"`: credits with up to two decimals. */
export function formatCredits(cents: number): string {
  return (cents / 100).toFixed(2).replace(/\.?0+$/, '');
}

/** `1250` → `"$12.50"`, `-500` → `"-$5.00"`. */
export function formatDollarMatch(cents: number): string {
  return `${cents < 0 ? '-' : ''}$${(Math.abs(cents) / 100).toFixed(2)}`;
}

/** Credits typed by an admin, rounded to whole cents (PRD E6). */
export function creditsToCents(value: number): number {
  return Math.round(value * 100);
}
